import { JobLookupField } from "@gui/widgets/JobLookup";
import { darkInputSx } from "./toolbarStyles";
import type { ToolbarJobSearchVM } from "./ToolbarJobSearch.vm";

// On the AppBar: white-on-dark like the selectors beside it, and a miss's message floats under the bar on a paper
// backing instead of growing the bar to fit it.
const ON_APP_BAR_SX = {
	gridColumn: 2,
	...darkInputSx,
	// The miss message floats on a paper backing below the bar, so it does not grow the AppBar;
	// shadow 1 like every floating panel (docs/design-system.md §3).
	"& .MuiFormHelperText-root": {
		position: "absolute",
		top: "100%",
		mt: 0.5,
		mx: 0,
		px: 1,
		py: 0.25,
		bgcolor: "background.paper",
		borderRadius: 1,
		boxShadow: 1,
		whiteSpace: "nowrap",
		zIndex: 1,
	},
} as const;

/** The search any admin reaches from every page. Desktop sits on the AppBar; mobile stacks in the overflow menu. */
export function ToolbarJobSearch({ vm, onAppBar }: { vm: ToolbarJobSearchVM; onAppBar: boolean }) {
	return (
		<JobLookupField
			key={vm.fieldKey}
			value={vm.value}
			onValueChange={vm.setValue}
			onFound={vm.onFound}
			onJobIdChosen={vm.onJobIdChosen}
			submitOnPaste
			inputRef={vm.inputRef}
			placeholder={onAppBar ? vm.placeholder : "Search jobs"}
			aria-keyshortcuts={onAppBar ? "Meta+K Control+K" : undefined}
			hideSubmit
			fullWidth
			stacked={!onAppBar}
			showDetails={onAppBar}
			sx={onAppBar ? ON_APP_BAR_SX : undefined}
		/>
	);
}
